import type { PrincipalIdentifierLocal } from '../api/types/PlatformLocal';

/**
 * DEC-RBAC-079/081 — Helper de PRESENTACIÓN del identificador de un usuario en las tablas.
 *
 * Regla (Andres): donde se listan usuarios, la columna del identificador muestra el PRINCIPAL del
 * tenant (Teléfono si el tenant es phone-primary, Email si es email-primary), con el OTRO dato como
 * secundario (sub-línea gris) si existe. Este módulo centraliza esa decisión para no duplicarla entre
 * `PlatformTenantUsersTable` (contexto platform) y `ScopedUsersTable` (contexto tenant-admin).
 *
 * Es lógica PURA (sin JSX ni RHF) a propósito: la celda arma el markup; aquí sólo se decide qué texto va
 * como principal, cuál como secundario y qué label lleva la columna.
 */

/** Label de la columna/campo según el identificador primario del tenant. */
export function principalIdentifierLabel(principalIdentifier: PrincipalIdentifierLocal): string {
    return principalIdentifier === 'PHONE' ? 'Teléfono' : 'Email';
}

/**
 * Dado el `{ email, phone }` de una fila y el identificador primario del tenant, resuelve qué mostrar:
 *  - `primary`: el dato del identificador PRINCIPAL del tenant (o `'—'` si la fila no lo trae).
 *  - `secondary`: el OTRO dato, sólo si existe y no está vacío (para la sub-línea gris); si no, `undefined`.
 */
export function resolveIdentifierDisplay(
    row: { email?: string; phone?: string },
    principalIdentifier: PrincipalIdentifierLocal,
): { primary: string; secondary?: string } {
    const email = row.email?.trim() ? row.email.trim() : undefined;
    const phone = row.phone?.trim() ? row.phone.trim() : undefined;

    if (principalIdentifier === 'PHONE') {
        return { primary: phone ?? '—', secondary: email };
    }
    return { primary: email ?? '—', secondary: phone };
}
